function toggleMobileNav() {
  const mobileNav = document.querySelectorAll(".mobile-nav__container");

  mobileNav.forEach((nav) => {
    nav.classList.toggle("active");
    document.body.style.overflow = nav.classList.contains("active")
      ? "hidden"
      : "";
  });
}

function closeMobileNav() {
  const mobileNav = document.querySelectorAll(".mobile-nav__container");

  mobileNav.forEach((nav) => {
    nav.classList.remove("active");
    document.body.style.overflow = "";
  });
}

function toggleSubmenu(submenuId) {
  const submenu = document.querySelectorAll(
    `[data-submenu-content="${submenuId}"]`
  );

  console.log(submenu);

  submenu.forEach((sub) => {
    sub.classList.toggle("active");

    const toggle = document.querySelector(`[data-submenu="${submenuId}"]`);
    if (toggle) {
      const icon = toggle.querySelector(".mobile-nav__submenu-icon");
      if (icon) {
        icon.textContent = sub.classList.contains("active") ? "-" : "+";
      }
    }
  });
}
